// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const copyFields = (source: any, destination: any): void => {
    Object.keys(source).forEach(key => {
        destination[key] = source[key];
    });
};
